/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UserAccountModifiableLimits
 */
export interface UserAccountModifiableLimits {
    /**
     * 
     * @type {string}
     * @memberof UserAccountModifiableLimits
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountModifiableLimits
     */
    'limitType': UserAccountModifiableLimitsLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserAccountModifiableLimits
     */
    'limit': number | null;
}

export const UserAccountModifiableLimitsLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type UserAccountModifiableLimitsLimitTypeEnum = typeof UserAccountModifiableLimitsLimitTypeEnum[keyof typeof UserAccountModifiableLimitsLimitTypeEnum];


